import Component from '../core/Component'

export default class Hero extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            content: null
        }
    }

    prepare() {
        let viewportPosition = 0

        document.addEventListener("scroll", this.handleScroll, {passive: true})
    }

    destroy() {
        document.removeEventListener('scroll', this.handleScroll)
    }

    handleScroll = ()=>{
        const viewportPosition = window.scrollY

        window.requestAnimationFrame(() => {
            this.render(viewportPosition)
          });
    }

    render(value) {
        let position = value * 0.5
        let opacity = 1 - (value * 0.003)

        this.ref.content.style.top = position + 'px'
        this.ref.content.style.opacity = opacity
    }
}